const options = {
  5: "bg-lime-700/5",
  10: "bg-lime-700/10",
  25: "bg-lime-700/25",
  50: "bg-lime-700/50",
  75: "bg-lime-700/75",
  90: "bg-lime-700/90",
  100: "bg-lime-700",
};

const from = {
  5: "from-lime-700/5",
  10: "from-lime-700/10",
  25: "from-lime-700/25",
  50: "from-lime-700/50",
  75: "from-lime-700/75",
  90: "from-lime-700/90",
  100: "from-lime-700",
};

export default function getBackgroundLime700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
